export enum InstagramAccountsErrors {
  LIST_FAILED = 'Unable to load Instagram accounts.',
  ACCOUNT_FAILED = 'Unable to load the Instagram account.',
  MEDIA_FAILED = 'Unable to load Instagram media.',
  INVALID_RESPONSE = 'The Instagram account response was invalid.',
}
